export default __webpack_public_path__ + "static/media/collapsed-logo.06e037f8.png";